import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-lightShow" }
const _hoisted_2 = { class: "p-4 space-y-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "py-4 text-left border-b-2 border-green-show" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold" }, "支払管理")
], -1)
const _hoisted_4 = { class: "pb-12" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "bg-white py-2 px-4 rounded shadow" }
const _hoisted_7 = { class: "flex justify-between" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "text-sm font-bold pb-2" }
const _hoisted_10 = { class: "text-sm" }
const _hoisted_11 = { class: "text-sm" }
const _hoisted_12 = { class: "fixed bottom-8 w-full px-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "table-cell align-middle text-white text-sm font-bold" }, " クレジットカードを追加する ")
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "space-y-4 py-8" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "space-y-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-left" }, "カード番号"),
  /*#__PURE__*/_createElementVNode("div", {
    id: "number-form",
    class: "p-2 border-b"
  })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "space-y-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-left" }, "有効期限"),
  /*#__PURE__*/_createElementVNode("div", {
    id: "expiry-form",
    class: "p-2 border-b"
  })
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "space-y-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-left" }, "セキュリティコード"),
  /*#__PURE__*/_createElementVNode("div", {
    id: "cvc-form",
    class: "p-2 border-b"
  })
], -1)
const _hoisted_19 = { class: "relative flex items-start" }
const _hoisted_20 = { class: "flex h-5 items-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3 text-sm" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "default",
    class: "font-medium text-gray-700"
  }, "デフォルトに設定する")
], -1)
const _hoisted_22 = {
  id: "error-text",
  class: "text-red-500 text-left text-sm"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "text-white text-center text-sm font-bold" }, "保存", -1)
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.userPaymentMethods.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_van_empty, { description: "登録している支払い方法がありません。" })
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userPaymentMethods, (paymentMethod) => {
          return (_openBlock(), _createElementBlock("div", {
            key: paymentMethod.paymentMethodId
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "flex grow space-x-2 text-left",
                  onClick: ($event: any) => (
                  paymentMethod.isDefault
                    ? ''
                    : _ctx.setIsDefault(paymentMethod.paymentMethodId!)
                )
                }, [
                  _createVNode(_component_CheckIcon, {
                    class: _normalizeClass(["w-6 h-6 my-auto text-green-lightShow", paymentMethod.isDefault ? '' : 'invisible'])
                  }, null, 8, ["class"]),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(paymentMethod.brand), 1),
                    _createElementVNode("p", _hoisted_10, "末尾 ****" + _toDisplayString(paymentMethod.last4), 1),
                    _createElementVNode("p", _hoisted_11, " 有効期限 " + _toDisplayString(paymentMethod.exp_month) + "/" + _toDisplayString(paymentMethod.exp_year), 1)
                  ])
                ], 8, _hoisted_8),
                (!paymentMethod.isDefault)
                  ? (_openBlock(), _createBlock(_component_XMarkIcon, {
                      key: 0,
                      class: "h-6 w-6 my-auto",
                      onClick: ($event: any) => (_ctx.deletePaymentMethod(paymentMethod.paymentMethodId!))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", {
        class: "flex justify-center bg-green-show py-3 px-4 rounded space-x-2 m-auto relative",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openAddPaymentMethodPopup && _ctx.openAddPaymentMethodPopup(...args)))
      }, _hoisted_14)
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.showAddPaymentPopup,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showAddPaymentPopup) = $event)),
      position: "bottom",
      style: {height: '80%'},
      closeable: true,
      round: true,
      class: "bg-gray-lightShow py-4 px-4",
      onClose: _ctx.closeAddPaymentMethodPopup,
      onOpened: _ctx.mountAddPaymentMethod
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _hoisted_17,
          _hoisted_18,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _withDirectives(_createElementVNode("input", {
                  id: "default",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isDefault) = $event)),
                  name: "default",
                  type: "checkbox",
                  class: "h-4 w-4 rounded border-gray-300 text-green-show focus:ring-green-show"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.isDefault]
                ])
              ]),
              _hoisted_21
            ])
          ]),
          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.errorMessage), 1)
        ]),
        _createElementVNode("div", {
          class: "bg-green-show w-full rounded-md py-3",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
        }, _hoisted_24)
      ]),
      _: 1
    }, 8, ["show", "onClose", "onOpened"])
  ]))
}